const Style = {

  base: 'inline-block mx-1 py-1 px-2.5 text-white uppercase text-xs rounded',
  red: 'tg-red-500',
  blue: 'bg-blue-500',
  green: 'tg-green-500',
  orange: 'bg-orange-500',
}

export default Style;